import React from 'react';
import { Info } from 'lucide-react';

/**
 * Guest selection block for ParticipantBookingPanel — shared verbatim by
 * both create and edit mode. Pills summarize the current selection (and
 * are the fastest way to remove one); the checklist below is still how
 * you add guests.
 */
const GuestPicker = ({ guests, selectedGuestIds, isGuestOnly, onToggleGuest, onToggleGuestOnly }) => (
  <div className="pbt-guest-block">
    <div className="pbt-guest-block__heading">
      <span>Guests</span>
      <span
        className="pbt-guest-info-icon"
        data-tooltip="A guest usually stays with the participant. Select “Guest only” if the participant is not staying in this room."
        tabIndex={0}
        role="img"
        aria-label="A guest usually stays with the participant. Select Guest only if the participant is not staying in this room."
      >
        <Info size={13} />
      </span>
    </div>
    {selectedGuestIds.length > 0 && (
      <div className="pbt-guest-pills">
        {selectedGuestIds.map((id) => {
          const g = guests.find((x) => x._id === id);
          if (!g) return null;
          return (
            <span key={id} className="pbt-guest-pill">
              {`${g.firstName || ''} ${g.lastName || ''}`.trim()}
              <button type="button" className="pbt-guest-pill__remove" onClick={() => onToggleGuest(id)}>×</button>
            </span>
          );
        })}
      </div>
    )}
    {guests.length > 0 ? (
      <ul className="pbt-guest-block__list">
        {guests.map((g) => (
          <li key={g._id} className="pbt-guest-block__item">
            <label className="pbt-guest-block__check">
              <input
                type="checkbox"
                checked={selectedGuestIds.includes(g._id)}
                onChange={() => onToggleGuest(g._id)}
              />
              <span>{`${g.firstName || ''} ${g.lastName || ''}`.trim() || '(No name)'}</span>
            </label>
          </li>
        ))}
      </ul>
    ) : (
      <div className="pbt-guest-block__empty">No guests registered.</div>
    )}
    <label className="pbt-guest-only-row">
      <input
        type="checkbox"
        checked={isGuestOnly}
        onChange={onToggleGuestOnly}
      />
      <span>Guest only &ndash; participant not staying in this room</span>
    </label>
  </div>
);

export default GuestPicker;
